// Canonical service-discipline registry — the single source of truth for
// clinic onboarding, settings toggles, booking, notes and staff professions.
export const DISCIPLINES = [
  { key: 'physiotherapy',        label: 'Physiotherapy',        sub: 'Movement, rehab, manual therapy' },
  { key: 'chiropractic',         label: 'Chiropractic',         sub: 'Spinal / joint adjustment' },
  { key: 'osteopathy',           label: 'Osteopathy',           sub: 'Whole-body manual treatment' },
  { key: 'massage_therapy',      label: 'Massage Therapy',      sub: 'Soft-tissue work + intake' },
  { key: 'spa',                  label: 'Spa & Wellness',       sub: 'Relaxation, hydro & thermal treatments' },
  { key: 'podiatry',             label: 'Podiatry',             sub: 'Foot & ankle medicine' },
  { key: 'podology',             label: 'Podology',             sub: 'Non-medical foot & nail care' },
  { key: 'occupational_therapy', label: 'Occupational Therapy', sub: 'Daily-living skills & adaptation' },
  { key: 'exercise_physiology',  label: 'Exercise Physiology',  sub: 'Clinical exercise programs' },
  { key: 'fitness',              label: 'Fitness & Training',   sub: 'Strength, conditioning & classes' },
];

export const disciplineLabel = (k) =>
  (DISCIPLINES.find(d => d.key === k)?.label) || String(k || '').replace(/_/g, ' ');
